import { useMutation } from '@apollo/client';
import React, { FC } from 'react';
import useNotifications from '../../../Notifications/useNotifications';
import { UPDATE_INVOICE } from '../graphql/mutations';
import { GET_INVOICES } from '../graphql/queries';
import ReceiptForm from '../ReceiptForm';
import { Receipt } from '../types';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const EditReceipt: FC = () => {
  const { id }= useParams<{ id: string }>();
  const navigate = useNavigate();
  const { state } = useLocation();
  const receipt = state.receipt;
  const { __typename, ...rest } = receipt;
  const [updateInvoice] = useMutation(UPDATE_INVOICE, {
    onError: () => addError('Something went wrong, please try again.'),
    onCompleted: () => { 
      addSuccess('Invoice updated');
      navigate('/receipts');
    },
    refetchQueries: [{ query: GET_INVOICES }]
  });
  const { addError, addSuccess } = useNotifications();

  const onSubmit = async (values: Receipt) => {
    try {
      const result = await updateInvoice({ variables: {
        id,
        values
      }})
      console.log(result)
    } catch(e) {
      console.log(e)
    }
  }
  return (
    <ReceiptForm title="Edit receipt" initialValues={rest} onSubmit={onSubmit}/>
  );
};

export default EditReceipt; 